import { render, staticRenderFns } from "./ReadOnlyLessons.vue?vue&type=template&id=61d04529&scoped=true&lang=pug&"
import script from "./ReadOnlyLessons.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyLessons.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyLessons.vue?vue&type=style&index=0&id=61d04529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d04529",
  null
  
)

export default component.exports